import {
  faArrowCircleLeft,
  faArrowCircleRight,
  faHomeLgAlt,
  faBuilding,
  faSackDollar,
  faUserAlt,
  faMoneyCheckEditAlt,
  faChartNetwork,
  faBell,
  faExchange,
  faQuestionCircle,
  faBooks,
  faBalanceScaleLeft,
  faFileMedical,
  faFileInvoice,
} from "@fortawesome/pro-light-svg-icons";
import {
  faBars,
  faHomeLgAlt as solidHome,
  faBuilding as Building,
  faSackDollar as sackDollar,
  faUserAlt as userAlt,
  faMoneyCheckEditAlt as moneyCheck,
  faChartNetwork as chartNetwork,
  faBell as bell,
  faExchange as exchange,
  faQuestionCircle as questionCircle,
  faBooks as books,
  faBalanceScaleLeft as balanceScale,
  faEllipsisH,
} from "@fortawesome/pro-solid-svg-icons";

export const ROUTES = {
  HOME: "/home",
  DASHBOARD: "/dashboard",
  COMPANY: "/companys",
  MANAGE_COMPANY: "/manage-company",
  PLAN: "/plans",
  CREATE_PLAN: "/manage-plan/create-plan",
  SUCCESS_PLAN: "/success-plan",
  MANAGE_PLAN: "/manage-plan",
  MANAGE_ELIGIBILITY: "/eligibility",
  FILESTATUSREPORT: "/file-status-report",
  FULLTRANSACTIONREPORT: "/full-transaction-report",
  MANAGE_VESTING: "/vesting",
  MAPPER: "/mapper",
  MANAGE_MAPPER: "/manage-mapper",
  MAPPER_HOME: "/mapper-profile-summary",
  MANAGE_EMPLOYEE: "/employees",
  MANAGE_CENSUS: "/manage-census/employee-information",
  MASTERS: "/masters",
  FEE: "/fee",
  CREATE_FEE: "/create-fee",
  FEE_RUN: "/fee-run",
  PAYROLL: "/payroll",
  MANAGE_PAYROLL: "/manage-payroll",
  MANAGE_TEMPMAP: "/manage-tempmap",
  PAYROLL_FILE_STATUS: "/payroll/file-status",
  PAYROLL_REPORTS: "/payroll/reports",
  MANAGE_MAINTENANCE: "/manage-maintenance",
  MANAGE_REPORTS: "/reports",
  CALCULATORS: "/calculators",
  ENROLLMENT: "/enrollment",
  TEMPLATES: "/templates",
  DOCO_CENTER: "/doco-center",
  DOCO: "/doco",
  SPONSOR: "/sponsor",
  OUTPUT_FILES: "/output-files",
  FORFEITURE: "/forfeiture",
  TRADE: "/trade",
  RKAAS: "/rkaas",
  TRANSACTION: "/transaction",
  MANAGE_COMMUNICATION: "/communication",
  DISTRIBUTION: "/distribution",
  WITHDRAWAL_REQUEST: "/distribution/withdrawal-request",
  LOAN_REQUEST: "/distribution/loan-request",
  WITHDRAWAL_SUMMARY: "/distribution/withdrawal-summary",
  LOAN_SUMMARY: "/distribution/loan-summary",
  MAPPING_TEMPLATES: "/mapping-templates",
  USER_REGISTRATION: "/user-registration",
};

export const MANAGE_PLAN_CONFIG_ROUTES = {
  PLAN: `${ROUTES.PLAN_CONFIG}/plans`,
  xxxsss: `${ROUTES.PLAN_CONFIG}/xfdddd`,

  COMPANY: `${ROUTES.PLAN_CONFIG}/company`,
  MASTERS: `${ROUTES.PLAN_CONFIG}/masters`,
  INVESTMENT: `${ROUTES.PLAN_CONFIG}/manage-investment`,
  ADD_INVESTMENT: `${ROUTES.PLAN_CONFIG}/add-investment`,
  CLEARING_PARTNER: `${ROUTES.PLAN_CONFIG}/clearing-partner`,
  ADVISOR: `${ROUTES.PLAN_CONFIG}/advisor`,
  HOLIDAY_CALENDAR: `${ROUTES.PLAN_CONFIG}/holiday-calendar`,
  ADD_HOLIDAY: `${ROUTES.PLAN_CONFIG}/add-new-holiday`,
  SCHEDULE_EXTENSION: `${ROUTES.PLAN_CONFIG}/schedule-extension`,
  MANAGE_PLAN_GROUP: `${ROUTES.PLAN_CONFIG}/manage-plan-group`,
  ADD_PLAN_GROUP: `${ROUTES.PLAN_CONFIG}/add-plan-group`,
  RESTRICTION: `${ROUTES.PLAN_CONFIG}/restriction`,
  SPECIFICATION_INFORMATION: `${ROUTES.FEE}/specification-information`,
};

export const mainMenuList = [
  // {
  //   name: "Home",
  //   label: "Home",
  //   route: ROUTES.HOME,
  //   icon: faHomeLgAlt,
  //   selectedIcon: solidHome,
  //   menuList: ["home"],
  // },
  {
    name: "Company",
    label: "Company",
    route: ROUTES.COMPANY,
    selectedIcon: Building,
    icon: faBuilding,
    menuList: ["companys", "manage-company"],
  },
  {
    name: "Plan",
    label: "Plan",
    route: ROUTES.PLAN,
    icon: faSackDollar,
    selectedIcon: sackDollar,
    menuList: ["plans", "manage-plan"],
  },
  {
    name: "Employees",
    label: "Employee",
    route: ROUTES.MANAGE_EMPLOYEE,
    icon: faUserAlt,
    selectedIcon: userAlt,
    menuList: ["employees", "manage-census"],
  },
  {
    name: "Payroll",
    label: "Payroll",
    route: ROUTES.PAYROLL,
    icon: faFileInvoice,
    selectedIcon: moneyCheck,
    menuList: ["payroll", "manage-payroll"],
  },
  {
    name: "Mapper",
    label: "Mapper",
    route: ROUTES.MAPPER_HOME,
    icon: faFileMedical,
    selectedIcon: chartNetwork,
    menuList: ["manage-mapper", "mapper-profile-summary"],
  },
  {
    name: "Rkaas",
    label: "rkaas",
    route: ROUTES.RKAAS,
    icon: faBalanceScaleLeft,
    selectedIcon: books,
    menuList: ["rkaas"],
  },
  {
    name: "Transaction",
    label: "transaction",
    route: ROUTES.TRANSACTION,
    icon: faMoneyCheckEditAlt,
    selectedIcon: books,
    menuList: ["transaction"],
  },
];
export const othersMenuList = [
  {
    name: "Eligibility",
    label: "eligibility",
    route: ROUTES.MANAGE_ELIGIBILITY,
    icon: faMoneyCheckEditAlt,
    selectedIcon: solidHome,
    menuList: ["eligibility"],
  },
  // testig table
  {
    name: "fileStatusReport",
    label: "fileStatusReport",
    route: ROUTES.FILESTATUSREPORT,
    icon: faMoneyCheckEditAlt,
    selectedIcon: solidHome,
    menuList: ["fileStatusReport"],
  },
  {
    name: "full-transaction-report",
    label: "full-report",
    route: ROUTES.FILESTATUSREPORT,
    icon: faMoneyCheckEditAlt,
    selectedIcon: solidHome,
    menuList: ["full report"],
  },
  {
    name: "Trade",
    label: "trade",
    route: ROUTES.TRADE,
    icon: faBalanceScaleLeft,
    selectedIcon: books,
    menuList: ["trade"],
  },
  {
    name: "Enrollment",
    label: "enrollment",
    route: ROUTES.ENROLLMENT,
    selectedIcon: faMoneyCheckEditAlt,
    icon: faMoneyCheckEditAlt,
    menuList: ["enrollment"],
  },
  {
    name: "Maintenance",
    label: "maintenance",
    route: ROUTES.MANAGE_MAINTENANCE,
    icon: faMoneyCheckEditAlt,
    selectedIcon: userAlt,
    menuList: ["maintenance", "manage-maintenance"],
  },
  {
    name: "Output Files",
    label: "outputfiles",
    route: ROUTES.OUTPUT_FILES,
    icon: faMoneyCheckEditAlt,
    selectedIcon: moneyCheck,
    menuList: ["outputfiles", "output-files"],
  },
  {
    name: "Communication",
    label: "communication",
    route: ROUTES.MANAGE_COMMUNICATION,
    icon: faMoneyCheckEditAlt,
    selectedIcon: chartNetwork,
    menuList: ["communication"],
  },
  {
    name: "Forfeiture",
    label: "forfeiture",
    route: ROUTES.FORFEITURE,
    icon: faMoneyCheckEditAlt,
    selectedIcon: balanceScale,
    menuList: ["forfeiture"],
  },
  {
    name: "Reports",
    label: "Reports",
    route: ROUTES.MANAGE_REPORTS,
    icon: faMoneyCheckEditAlt,
    selectedIcon: sackDollar,
    menuList: ["reports"],
  },
  {
    name: "masters",
    label: "masters",
    route: ROUTES.MASTERS,
    icon: faBooks,
    selectedIcon: books,
    menuList: ["masters"],
  },
  {
    name: "fee",
    label: "fee",
    route: ROUTES.FEE,
    icon: faMoneyCheckEditAlt,
    selectedIcon: sackDollar,
    menuList: ["fee", "create-fee"],
  },
  {
    name: "UserRegistration",
    label: "User Registration",
    route: ROUTES.USER_REGISTRATION,
    icon: userAlt,
    selectedIcon: userAlt,
    menuList: ["user-registration"],
  },
];
export const includeExcludeIgnoreOptions = [
  {
    label: "Include",
    value: 1,
  },
  {
    label: "Exclude",
    value: 2,
  },
  {
    label: "Ignore",
    value: 3,
  },
];

export const optionsinFilter = [
  {
    label: "Oldest First",
    value: "true",
  },
  {
    label: "Latest First",
    value: "false",
  },
];

export const fileMetaOption = [
  {
    label: "Plan Name",
    value: "ABC",
  },
  {
    label: "Plan Id",
    value: "345",
  },
  {
    label: "File Create DataTime",
    value: "2022-11-30T08:33:55",
  },
  {
    label: "Indicator",
    value: "true",
  },
  {
    label: "Payroll Date",
    value: "12/09/2000",
  },
  {
    label: "Sub Id",
    value: "1567",
  },
  {
    label: "TotalPayroll Amount",
    value: "10000",
  },
  {
    label: "ACH Number",
    value: "100",
  },
  {
    label: "Total Contribution",
    value: "1000",
  },
  {
    label: "Total Compensation",
    value: "2000",
  },
];

export const yesNoOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const feeRunTypeOptions = [
  {
    label: "One Time",
    value: 1,
  },
  {
    label: "Recurring",
    value: 2,
  },
];

export const statusOptions = [
  {
    label: "Active",
    value: 2,
  },
  {
    label: "Inactive",
    value: 3,
  },
];

export const deductFeeOption = [
  {
    label: "Account Balance",
    value: 1,
  },
  {
    label: "Vested Balance",
    value: 2,
  },
];

export const FeesApplicableOptions = [
  {
    label: "All plans",
    value: 1,
  },
  {
    label: "Specific plan(s)",
    value: 2,
  },
  {
    label: "Plan group(s)",
    value: 3,
  },
];

export const fileNameOptions = [
  {
    label: "Enter",
    value: 1,
  },
  {
    label: "Select",
    value: 2,
  },
  {
    label: "Custom",
    value: 3,
  },
];

export const calendarFrequencyOptions = [
  {
    label: "Years",
    value: 1,
  },
  {
    label: "Months",
    value: 2,
  },
];

export const inverseYesNoOptions = [
  {
    label: "Yes",
    value: false,
  },
  {
    label: "No",
    value: true,
  },
];

export const Enrollment_applyADITo = [
  {
    label: "None",
    value: 0,
  },
  {
    label: "Suspension",
    value: 1,
  },
  {
    label: "Termination",
    value: 2,
  },
  {
    label: "Both",
    value: 3,
  },
];
export const Enrollment_autoDeferralIncreaseApplicableTo = [
  {
    label: "Auto",
    value: 1,
  },
  {
    label: "Manual",
    value: 2,
  },
  {
    label: "Both",
    value: 3,
  },
];

export const Enrollment_periodOfIncrease = [
  {
    label: "Calendar year",
    value: 1,
  },
  {
    label: "Plan year",
    value: 2,
  },
  {
    label: "Date of participation",
    value: 3,
  },
];

export const Enrollment_allocationPercentageForReHire = [
  {
    label: "Original allocation",
    value: 1,
  },
  {
    label: "Other",
    value: 2,
  },
];
export const PLAN_STATUSES = {
  UnderConstruction: 0,
  PENDING_APPROVAL: 1,
  PENDING_ACTIVATE: 2,
  ACTIVATED: 3,
  INACTIVE: 4,
  TERMINATED: 5,
};

export const MAPPER_PLAN_STATUS = {
  0: "UnderConstruction",
  1: "ReadyFor",
  2: "Approved",
  3: "Active",
  4: "In Active",
  5: "Terminated",
};

export const FLOW_TYPES = {
  ADD: "add",
  EDIT: "edit",
  SAVE: "save",
  VIEW: "view",
};
export const FEE_TYPE_MAPPING = {
  BalanceBased: 1,

  InvestmentBased: 2,
};
export const OPTIONS_DATA_MAPPER = {
  PERIOD_OF_CALCULATION: {
    0: "Per Payroll Period",
  },
  FORFEITURE_FUNDIN: {
    1: " Same plan year",
    2: "Succeeding plan year",
  },
  TRANSFER_TYPE: {
    1: "Percentage",
    2: "Dollars",
    4: "Units",
    // 4: "All",
  },
  CALCULATIONFEE_TYPE: {
    1: "Balance based",

    2: "Investment based",
  },

  FEE_RUN: {
    1: "One-Time",
    2: "Recurring",
  },

  FEE_PROCESS: {
    1: "Immediate",
    2: "Future",
  },

  BASIS_OF_DATE: {
    1: "Process Date",
    2: "Other",
  },

  FEE_FREQUENCY: {
    1: "Annually",
    2: "Semi-Annually",
    3: "Monthly",
    4: "Semi-Monthly",
    5: "Quarterly",
    6: "Weekly",
    7: "Daily",
  },

  BASIS_FREQUENCY: {
    1: "Month(s) back",
    2: "Week(s) back",
    3: "Day(s) back",
  },

  RUNFEE_FOR: {
    1: "All Employees",

    2: "Active Employees",
  },
  TRANSFER_COUNT_STARTS_FROM: {
    1: "Beginning of the Plan Year",
    2: "Transfer Effective Date",
  },
  PERIODIC_REBALANCE_REQUIRED: {
    1: "Yes",
    2: " No",
    3: "Allow Participant To Choose",
  },
  TRANSFER_FREQUENCY: {
    1: "Monthly",
    2: "Quarterly",
    3: "Semi-Annually",
    4: "Annually",
  },
  REALLOCATION_COUNT_STARTS_FROM: {
    1: "Beginning of the Plan Year",
    2: "First Reallocation Date",
  },
  BUSINESS_TYPE: {
    1: "LLC",
    2: "PLC",
    3: "C-Corp",
    4: "S-Corp",
    5: "Partnership",
    6: "Sole Prop.",
    7: "Others",
  },
  COMPANY_TYPE: {
    0: "Regular",
    1: "MEP",
    2: "PEP",
  },
  TAXED_AS: {
    1: "Corp",
    2: "S-Corp",
    3: "Partner or Sole ",
  },
  MODE_OF_HRS_COMP: {
    1: "PayPeriod",
    2: "Year To Date",
  },
  MODE_OF_FUNDING: {
    1: "ACH Credit",
    2: "ACH Debit",
  },
  WITHDRAWAL_TYPE: {
    1: "Inservice",
    2: "Hardship",
    3: "RequiredMinimumDistribution",
    4: "SeparationFromService",
    5: "Permissible",
    6: "ForceOut",
  },
  PAYROLLFREQUENCY_TYPE: {
    1: "Daily",
    2: "Weekly",
    3: "SemiMonthly",
    4: "Monthly",
    5: "Quarterly",
    6: "SemiAnnually",
    7: "Annually",
    8: "BiWeekly",
  },
  EMPLOYMENT_STATUS: {
    1: "Active",
    2: "Retired",
    3: "Terminated ",
    4: "Leave",
    5: "Military Leave",
    6: "Deceased",
    7: "Disabled",
    8: "Others",
  },
  EMPLOYEE_CLASSIFICATION_TYPE: {
    1: "Location",
    2: "Division",
    3: "Department",
    4: "Employee Type",
    5: "Excluded Class",
    6: "Union Indicator",
    7: "Client Eligibility",
    8: "Others",
  },
  PAY_DATE_BEHAVIOUR: {
    0: "No Change",
    1: "Move to Prior Business Date",
    2: "Move to Next Business Date",
  },
  SOURCES_STATUS_TYPE: {
    0: "Incomplete",
    1: "Complete",
  },
  SOURCES_ADDED_TOPLAN: {
    0: "",
    1: "Added To Plan",
  },
  SOURCE_CATEGORY_TYPES: {
    2: "Employee Deferral Sources",
    4: "Employee Other Sources",
    6: "Employer Match Sources",
    5: "Employer Discretionary Sources",
    7: "Employer Match Roth Sources",
    8: "Employer Non-elective Roth Sources",
    9: "Employer Other Sources",
    10: "Prevailing Wages",
  },
  SOURCES_FORM_TYPES: {
    1: "Employee",
    2: "Employer",
  },
  SOURCES_FORM_EMPLOYEE_CATEGORIES: {
    2: "Deferral",
    4: "Other",
  },
  SOURCES_EMPLOYER_CATERGORIES: {
    5: "Discretionary",
    6: "Match",
    7: "Match Roth",
    8: "Non-elective Roth",
    10: "Prevailing Wages",
    9: "Other",
  },
  SOURCES_FORM_DEFERRAL_SUB_CATEGORIES: {
    4: "Pre Tax",
    5: "Roth",
    6: "After Tax",
  },
  SOURCES_FORM_DEFERRAL_SUB_SUB_CATEGORIES: {
    1: "Regular",
    2: "Catch-Up",
  },
  SOURCES_FORM_OTHER_SUB_CATEGORIES: {
    7: "Pre Tax Rollover",
    8: "Roth Rollover",
    9: "After Tax Rollover",
  },
  SOURCES_FORM_EMPLOYER_OTHER_SUB_CATEGORIES: {
    1: "QMAC",
    2: "QNEC",
  },
  ALLOCATION_RULES_CONTRIBUTION_TYPE: {
    1: "Percentage",
    2: "Dollar",
  },
  ALLOCATION_RULES_PRCNT_REHIRES: {
    1: "Original Allocation Percentage",
    2: "Other",
  },
  SOURCES_CONTRIBUTION_METHOD: {
    1: "Check",
    2: "Wire",
    3: "Both",
  },
  SOURCES_EMPLOYER_RESPONSIBLE_FOR_CALC: {
    1: "Client",
    2: "Core",
    3: "Validate",
  },
  SOURCES_ELIGIBLE_PAY_DETERMINATION: {
    1: "Pay Date.",
    2: "Pay Period End Date",
  },
  SOURCE_SAFE_HARBOUR_TYPES: {
    1: "BASIC",
    2: "QACA",
    3: "Enhanced",
  },
  SOURCE_SAFE_HARBOUR_CATEGORIES: {
    1: "Regular",
    2: "QACA1"
  },
  SOURCE_EMPLOYER_MATCH_CONTR_TYPE: {
    2: "Percentage Match on Deferral",
    3: "Tiered Match",
  },
  SOURCE_EMPLOYER_DISCRETIONARY_CONTR_TYPE: {
    1: "Percentage Of Compensation",
  },
  SOURCE_QMAC_QNEC_TYPE: {
    1: "Percentage",
    2: "Dollar",
  },
  ELIGIBILITY_TYPE: {
    1: "Plan",
    2: "Source",
  },
  ELIGIBILITY_STATUS: {
    0: "Eligible",
    1: "Ineligible",
  },
  ENTRYDATECLASSIFICATION_TYPE: {
    1: "Plan",
    2: "Source",
  },
  ENTRYDATECLASSIFICATION_CRITERIA: {
    1: "First day of the month",
    2: "First day of the payroll period",
    3: "First day of the quarter",
    4: "First day of the plan year or first day of seventh month plan year",
    5: "First day of the plan year",
    6: "Immediate",
    7: "Others",
  },
  ENTRYDATECLASSIFICATION_ADDITIONALRULE: {
    1: "Yes",
    2: "No",
  },
  ENTRYDATECLASSIFICATION_PROSPECTIVEORRETROSPECTIVE: {
    1: "Following",
    2: "Preceding",
    3: "Nearest",
  },
  EXCUSION_TYPE: {
    1: "Date of hire",
    2: "Employee classification",
    3: "Both",
    0: "None",
  },
  DATE_OFHIRE: {
    1: "Hired on or before",
    2: "Hired between",
  },
  VESTING_METHOD: {
    1: "Hours Of Serivce",
    //2: "Equivalency",
    2: "Elapsed Time",
    3: "Equivalency",
  },
  ACCOUNT_TYPE: {
    1: "Savings",
    2: "Current",
  },
  ACCOUNT_STATUS: {
    1: "Active",
    2: "Inactive",
  },
  RETIREMENT_TYPE: {
    1: "Age",
    2: "Years of Service",
    4: "Years of Participation",
  },
  RETIREMENT_DATE_OPTIONS: {
    1: "Date the participant reaches early retirement",
    2: "First day of the month the participant reaches early retirement",
  },
  YEARS_OF_SERVICE_OPTIONS: {
    1: "Eligibility YOS",
    2: "Vesting YOS",
  },
  NORMAL_RETIREMENT_DATE_OPTIONS: {
    1: "Date the participant reaches normal retirement",
    2: "First day of the month the participant reaches normal retirement",
  },
  ENROLLMENT_PLAN_ENTRYDATE: {
    1: "First day of the month",
    2: "First day of the payroll period",
    3: "First day of the quarter",
    4: "First day of the plan year or first day of seventh month plan year",
    5: "First day of the plan year",
    6: "Immediate",
    7: "Others",
  },
  ENROLLMENT_PROSPECTIVEORRETROSPECTIVE: {
    1: "Following",
    2: "Preceding",
    3: "Nearest",
  },
  PAYROLL_FILE_STATUS_DATA: {
    0: "All",
    1: "Creation in progress",
    2: "Upload in progress",
    3: "Error Correction Required",
    4: "Pending Submission",
    5: "Awaiting Funding",
    6: "Awaiting Trade",
    7: "Completed",
    8: "Cancelled",
    9: "Deleted",
    12: "Error in File Processor",
    13: "SystemFailure",
    14: "Awaiting Fund Confirmation",
    15: "Payroll Funded",
    16: "Funding Failed",
  },
  LOAN_REPAYMENT_DETAIL_LOAN_STATUS: {
    0: "All",
    1: "Draft",
    2: "Awaiting Approval",
    3: "Rejected",
    4: "Awaiting Trade",
    5: "Awaiting Trade Confirmation",
    6: "Trade Rejected",
    7: "Active",
    8: "Delinquent",
    9: "Default - Deemed Distribution",
    10: "Default - Benefit Offset",
    11: "Suspended",
    12: "Closed",
    13: "Deleted",
    14: "Outstanding",
  },
  LOAN_REPAYMENT_DETAIL_SUBMMITED_DATE: {
    0: "All",
    1: "Submitted date",
    2: "Activated date",
    3: "Closed date",
  },
  // ENROLLMENT_PLAN_ENTRYDATE: {
  //   1: "Immediate",
  //   2: "First day of the month coinciding with or next following the date an employee meets the eligibility requirements",
  //   3: "First day of the month following the date an employee meets the eligibility requirements",
  //   4: "First day of the payroll coinciding with or next following the date an employee meets the eligibility requirements",
  //   5: "First day of the payroll period following the date an employee meets the eligibility requirements",
  //   6: "First day of the quarter coinciding with or next following the date an employee meets the eligibility requirements",
  //   7: "First day of the quarter following the date an employee meets the eligibility requirements",
  //   8: "First day of the plan year coinciding with or next following the date an employee meets the eligibility requirements",
  //   9: "First day of the plan year following the date an employee meets the eligibility requirements",
  //   10: "First day of the plan year or first day of the seventh month of the plan year coinciding with or next following the date an employee meets the eligibility requirements",
  //   11: "First day of the plan year or first day of the seventh month of the plan year following the date an employee meets the eligibility requirements",
  // },
  COMPENSATION_DEFINITIONS: {
    1: "IRC Section 3401(a)-Compensation subject to withholding",
    2: "IRC Section 3401(a)-Compensation subject to withholding + pre-tax amounts",
    3: "IRC Section 6041/6051 W2",
    4: "IRC Section 6041/6051 W2 + pre-tax amounts",
    5: "IRC Section 415(C)-All income",
    6: "IRC Section 415(C)-All income + pre-tax amounts",
  },
  COMPENSATION_CALCULATIONS: {
    1: "Paid after becoming a participant",
    2: "Paid during Plan Year",
    3: "Paid during Calendar Year",
  },
  COMPENSATION_CATEGORY_CALCULATIONS: {
    1: "Include",
    2: "Exclude",
    3: "Ignore",
  },
  COMPENSATION_EXCLUDE_TYPES: {
    1: "Overtime",
    2: "Bonus",
    3: "Commissions",
    4: "Vacation Pay",
    5: "Other",
  },
  COMPENSATION_EMPLOYEE_TYPES: {
    1: "HCE",
    2: "ALL",
  },
  PERIODIC_PAYMENT_OPTIONS: {
    1: "Specific Tenure",
    2: "Specific Dollar",
    4: "Amortization Method",
    8: "Annuitization Method",
  },
  PERIODIC_PAYMENT_OPTIONS_ENUM: {
    SpecificTenure: 1,
    SpecificDollar: 2,
    AmortizationMethod: 4,
    AnnuitizationMethod: 8,
  },
  DISTRIBUTIONS_TYPE: {
    1: "In-Service",
    2: "Hardship",
    3: "Required Minimum Distribution",
    4: "Separation from Service",
    5: "Permissible Withdrawal",
    6: "Force out",
    7: "Qualified Birth and Adoption Distribution",
  },
  USER_ROLES: {
    1: "Admin",
    2: "Sponsor",
    3: "Participant",
    5: "PRI",
    6: "PRPR",
    7: "PRQC",
    8: "VOU",
    9: "SPU",
    10: "PLSH",
    11: "PLSM",
    12: "PLSL",
  },
  DISTRIBUTIONS_SOURCE_CATEGORY: {
    0: "All",
    2: "Employee Deferral Sources",
    4: "Employee Other Sources",
    5: "Employer Discretionary Sources",
    6: "Employer Match Sources",
    7: "Employer Match Roth Sources",
    8: "Employer NonElective Roth Sources",
    9: "Employer Other Sources",
  },
  DISTRIBUTIONS_HARDSHIP_REASONS: {
    1: "Certain medical expenses",
    2: "Costs related to purchasing a principal residence",
    3: "College tuition and education fees for the next 12 months",
    4: "Expenses required to avoid a foreclosure or eviction",
    5: "Burial or funeral costs",
    6: "Home repair after a natural disaster",
    7: "Covid '19",
    8: "Other",
  },
  DISTRIBUTION_WITHDRAWAL_TYPE: {
    1: "Dollar",
    2: "Percentage",
  },
  DISTRIBUTION_DETECT_FEES_FROM: {
    1: "Account Balance",
    2: "Request Amount",
  },
  DISTRIBUTION_DETECT_FEES_FROM_RMD: {
    2: "Request Amount",
  },
  INVESTMENT_TYPES: {
    1: "Model Portfolio",
    2: "Annuity",
    3: "Bond",
    4: "Brokerage",
    5: "CCT Fund",
    6: "Index Fund",
    7: "Lifestyle",
    8: "Mutual Fund",
    9: "Stock Fund",
    10: "Self-Directed",
    11: "Cryptocurrency",
  },
  INVESTMENT_CATEGORY: {
    1: "Aggressive Allocation",
    2: "Annuity",
    3: "Bank Loan",
    4: "Bear Market",
    5: "Communications",
    6: "Equity Energy",
    7: "Financials",
    8: "Health",
    9: "India Equity",
    10: "Multicurrency",
  },
  TYPE_OF_EARNINGS: {
    1: "Captial Gains",
    2: "Accrual",
    4: "Dividends",
  },
  DIVIDEND_TYPE_MASTER: {
    1: "Periodic",
    2: "Equity accural",
    3: "Compounded equity accural",
  },
  DIVIDEND_PROCESSING_FREQUENCY_MASTER: {
    1: "Monthly",
    2: "Quarterly",
    3: "Semi - Annually",
    4: "Annually",
  },
  DIVIDEND_PROCESSING_OPTION: {
    1: "Pass Through",
    2: "Reinvest",
  },
  EXCLUDE_INVESTMENT_FROM: {
    1: "Master timings restrictions",
    2: "Redemption fee processing",
  },
  DIVIDEND_TYPE: {
    1: "Accrual",
    2: "Equity",
  },
  DIVIDEND_PROCESSING_DATE: {
    1: "Annually",
    2: "Quarterly",
    3: "Monthly",
    4: "Semi Monthly",
  },

  TEMP_INVESTMENTS: {
    1: "investment 01",
    2: "investment 02",
    3: "investment 03",
    4: "investment 04",
    5: "investment 05",
    6: "investment 06",
    7: "investment 07",
    8: "investment 08",
    9: "investment 09",
    10: "investment 10",
    11: "investment 11",
    12: "investment 12",
    13: "investment 13",
    14: "investment 14",
    15: "investment 15",
  },
  PROSPECTUS_DELIVERY_METHOD: {
    1: "Online",
    2: "Mail",
  },
  FREQUENCY_OF_PROSPECTUS_DISCLAIMER: {
    1: "Do Not Show",
    2: "Every Transfer",
    3: "Transfers into New Investments only",
  },
  POSTING_RULES: {
    1: "Trade Date",
    2: "Settlement Date",
  },
  CLEAING_PARTNER_ACCOUNT_ID: {
    1: 30239900122,
    2: 23244244213,
    3: 23244232341,
  },
  CLEARANCE_TIME: {
    1: "Hours",
    2: "Minutes",
  },
  INVESTMENT_VOLATILITY: {
    1: "Low",
    2: "Low to Moderate",
    3: "Moderate",
    4: "Moderate to High",
    5: "High",
  },
  INVESTMENT_SHARE_CLASS: {
    1: "None",
    2: "Class R1",
    3: "Class R2",
    4: "Class R3",
    5: "Class R4",
    6: "Class R5",
    7: "Class R6",
  },
  INVESTMENT_OBJECTIVE: {
    1: "Interest income without risk of loss of principal",
    2: "Long term growth of capital",
    3: "Match the performance of russell 2000 index",
    4: "Maximum total return",
    5: "Match the performance of standard & poor's 500 (S& P 500) index",
  },
  RESTRICTED_PERIOD: {
    1: "Days",
    2: "Weeks",
    3: "Months",
    4: "Years",
  },
  LOAN_TYPE: {
    1: "General Purpose",
    2: "Residential",
    3: "Other",
  },
  MANAGE_LOAN_TYPE: {
    1: "General Purpose",
    2: "COVID-19",
    3: "Hurricane",
    4: "Residential 00",
  },
  MAXIMUM_AMOUNT: {
    1: "Allowed by Loan Regulators",
    2: "Percentage of Balance",
    3: "Other",
  },
  CURE_PERIOD: {
    1: "End of Calendar Quarter following default quarter",
    2: "Fixed Number of days",
  },
  CURE_PERIOD_EMPLOYEE_TERMINATION: {
    1: "End of Calendar Quarter following default quarter",
    2: "Fixed Number of days",
  },
  SERVICE_REQUIREMENT_FOR_LOAN: {
    1: "Months",
    2: "Years",
  },
  LOAN_INTEREST_RATE: {
    1: "Prime",
    2: "Prime + a%",
    3: "Other",
  },
  REASON_FOR_LOAN_SUSPENSION: {
    1: "Leave of Absence (LOA)",
    2: "Military Leave of Absence (MLOA)",
    3: "Others",
  },
  STATUS_FOR_PLAN: {
    1: "93",
  },
  STATUS_FOR_SOURCE: {
    1: "2058",
  },
  TEMP_APPLICABLE_TYPES: {
    1: "Allocation",
    2: "Reallocation",
    4: "Rebalancing",
    8: "Transfer In",
    16: "Transfer out",
    32: "Insider",
    64: "Rollover In",
    128: "Loans Hardship",
    256: "In service Withdrawal",
    512: "Hardship Withdrawal",
    1024: "SFS Withdrawal",
    2048: "RMD",
    4096: "Force out",
    8192: "Permissible withdrawal",
    16384: "Fee",
    // 6: "Transfer Out Hardship",
    // 7: "Withdrawal In-Service",
    // 8: "Withdrawal",
  },
  MODEL_INV_RISK_TYPE: {
    1: "Aggressive",
    2: "Moderate",
    3: "Average",
  },
  SOURCE_NAME_STATUS: {
    1: "EMP-PT",
    2: "ER-DISC",
    3: "EMP-ROTH",
    4: "ER-MATCH",
    5: "EMP-PT",
  },
  // LOAN_STATUS: {
  //   1: "Active",
  //   2: "Default",
  //   3: "Deferred",
  //   4: "Closed",
  // },
  PLAN_CATERGORY: {
    0: "Regular",
    1: "MEP",
    2: "PEP",
    3: "Prototype",
    //4: "Common Remitter",
  },
  ELIBILITY_STATUS: {
    0: "Not Eligible",
    1: "Eligible",
  },
  ANNUITY_PAYMENTS: {
    1: "Fixed Date",
    2: "Participant Selected",
  },
  PAYMENT_FREQUENCY_RMD: {
    1: "Fixed Date",
    2: "Participant Selected",
  },
  DISTRIBUTION_ALLOCATION: {
    1: "Prorata of Choice",
    2: "Allow me to choose",
  },
  PAYMENT_METHOD: {
    1: "One time payment",
    2: "Periodic Payment",
  },
  PAYMENT_METHOD_APPLICABLE: {
    1: "Check",
    2: "EFT",
  },
  RESTRICTIONS_APPLICABLE: {
    1: "Age",
    2: "Plan YOS",
  },
  PLAN_TYPES: {
    1: "401(k)",
    2: "403(b)",
    3: "457",
    4: "SEP",
    5: "Money purchase",
    6: "Profit sharing",
    7: "SIMPLE IRA",
    8: "IRA",
    9: "SIMPLE 401(k)",
    10: "Defined benefit",
    11: "401(a)",
    12: "Starter 401(k)",
    13: "Safe Harbor 403(b)",
  },
  PLAN_STATUS_LIST: {
    0: "UnderConstruction",
    1: "ReadyForApproval",
    2: "Approved",
    3: "Active",
    //4: "InActive",
    //5: "Terminated",
  },
  PLAN_STATUS_LIST_0: {
    0: "UnderConstruction",
    1: "ReadyForApproval",
    2: "Approved",
    3: "Active",
    4: "InActive",
    5: "Terminated",
  },
  PLAN_LEVEL: {
    1: "Master",
    2: "Adopting Employer",
  },
  ALLOCATION_FORMULA_APPLIES_TO: {
    1: "EmployeeClassification",
  },
  ELIGIBILITY_RULES: {
    1: "Date of Hire",
    2: "Employee Classification",
    3: "Both Date of Hire and Employee Classification",
    0: "None",
  },
  ADDITIONAL_ELIGIBILITY_RULES: {
    //1: "Date of Hire",
    2: "Employee Classification",
    //3: "Both Date of Hire and Employee Classification",
  },
  ADDITIONAL_ENTRYDATE_RULES: {
    //1: "Date of Hire",
    1: "Employee Classification",
    //3: "Both Date of Hire and Employee Classification",
  },
  SERVICE_DEFINITIONS: {
    1: "Hours of service",
    2: "Elapsed Time",
    3: "Equivalency",
  },
  ELIGIBILITY_REQUIREMENT: {
    1: "Age",
    2: "Service",
    3: "Both Age and Service",
  },
  ELIGIBILITY_CALCULATION: {
    1: "Anniversary of Hire",
    2: "Plan year after Anniversary of Hire",
    3: "Other Computational Period",
  },
  COMPUTATION_PERIOD: {
    2: "Plan Year",
  },
  SERVICE_REQUIREMENT: {
    1: "One year of service",
    2: "Two years of service",
  },
  ONE_YEAR_SERVICE_REQUIREMENT: {
    1: "One year of service",
  },
  CREDIT_PERIOD: {
    1: "At the end of eligibility calculation period",
    2: "Immediately after the hours condition is satisfied",
  },
  Service_Credit_Day: {
    1: "Same day",
    2: "Subsequent day",
  },
  BREAK_SERVICE_RULE: {
    1: "One Year Hold Out",
    2: "Rule of parity",
  },
  LENGTH_OF_SERVICE: {
    1: "Days",
    2: "Months",
    3: "Years",
  },
  DATE_OF_HIRE: {
    1: "Hired on or after",
    2: "Hired on or before",
    3: "Hired between (inclusive)",
  },
  // ADDITIONAL_DATE_OF_HIRE: {
  //   1: "Hired on or after",
  //   // 2: "Hired on or before",
  //   // 3: "Hired between (inclusive)",
  // },
  WITHDRAWAL_LIMIT_PERIOD: {
    1: "Annually",
    // 2: "Monthly",
    2: "Quarterly",
    3: "SemiAnnually",
    4: "NotApplicable",
  },
  MINIMUM_WITHDRAWAL_LIMIT: {
    1: "EACA",
    2: "QACA",
    3: "None",
  },
  VESTED_AT: {
    1: "Death",
    2: "Disability",
    4: "NRA",
    8: "ERA",
  },
  VESTING_METHODS: {
    1: "Hours of Service",
    2: "Elapsed Time",
    3: "Equivalency",
  },
  VESTING_COMPUTATION_PERIODS: {
    // 1: "Anniversary of Hire",
    2: "Plan Year",
  },
  VESTING_PAST_PERIOD_COMPUTATION: {
    1: "Compute full years",
    2: "Compute half years",
    3: "Do not compute",
  },
  VESTING_SERVICE_CREDIT_PERIODS: {
    1: "At the end of Computation Period",
    2: "Immediately after the Hours condition is satisfied",
  },
  VESTING_BREAK_IN_SERVICE_RULE: {
    1: "One Year Hold Out",
    2: "Rule of Parity",
    3: "Five Years BIS",
  },
  FORFEITURE_TREATMENTS: {
    1: "Allocate to Participants",
    2: "Plan Expenses",
    4: "Reduce ER Contributions",
    8: "Reduce Match Contributions",
  },
  FORFEITURE_ENABLED_FORFEITURE_TREATMENT: {
    1: "Allocate to Participants",
    2: "Plan Expenses",
  },
  BASIC_SERVER_RULES: {
    1: "One Year Holdout",
    2: "Rule Of Parity",
    3: "5 Years Break In Service Rule",
  },
  GENDER: {
    M: "Male",
    F: "Female",
    U: "Unknown",
  },
  MARITAL_STATUS: {
    S: "Single",
    M: "Married",
    D: "Divorced",
    W: "Widower",
  },
  RECORD_TYPES_OPTIONS: {
    0: "All records",
    1: "Error records",
  },
  OPTOUT_RESET_FREQUENCY: {
    1: "Plan year start Date",
    2: "Anniversary of optout",
  },

  ENROLLMENT_APPY_ADI: {
    1: "Suspension",
    2: "Termination",
    3: "Both",
  },
  ADDITIONAL_AUTO_ENROLLMENT_OPTIONS: {
    1: "Date Of Hire",
    2: "Employee Classification",
    3: "Both",
    0: "None",
  },
  SCHEDULER_FREQUENCY: {
    1: "Minutes",
    2: "Hours",
    3: "Day",
  },
  ROAD_TRIP_OCCURANCE_DEFINITION: {
    1: "Transfer in followed by a transfer out",
    2: "Transfer out followed by a transfer in",
  },
  MARKET_TIMING_RULES: {
    1: "Follow Investment level MTRs",
    2: "Always exclude from MTRs",
  },
  FAILED_RULE_RESULT: {
    1: "Warn participant",
    2: "Block transaction",
    3: "Block future transaction",
  },
  INCLUDE_INVESTMENT_IN: {
    1: "Global Level",
    2: "Company Level",
  },
  ACCOUNT_TYPE_MASTER: {
    1: "Units",
    2: "Shares",
  },
  INVESTMENT_STATUS_MASTER: {
    1: "Open",
    2: "Closed",
    3: "Close to new investment",
    4: "Suspended",
  },
  REDEMPTION_SELL_TRANSACTIONS: {
    1: "Loan Disbursement",
    2: "Distributions",
    4: "Transfers",
    8: "Manual Rebalancing",
    16: "Auto-Rebalancing",
    32: "Fees",
    64: "Adjustments",
  },
  REDEMPTION_BUY_TRANSACTIONS: {
    1: "Contributions",
    2: "Loan Repayments",
    8: "Dividends",
    16: "Transfers",
    32: "Rollover in",
    64: "Manual Rebalancing",
    128: "Auto-Rebalancing",
    256: "Adjustments",
  },
  REDEMPTION_HOLDING_PERIOD: {
    1: "Calendar Days",
    2: "Business Days",
  },
  REALLOCATION_PERIOD: {
    1: "Annually",
    2: "Monthly",
    3: "Quarterly",
    4: "Semi-Annually",
    5: "Daily",
    6: "Weekly",
    7: "Bi-Weekly",
    8: "Semi-Monthly",
  },
  ENROLLMENT_INVITE: {
    1: "Immediately after employee record is created",
    2: "Fixed number of days before Entry Date",
    3: "Once employee meets his eligibility requirements",
  },
  CODE_OPTIONS_ROLLOVER: {
    1: "Code B: Designated Roth account distribution",
    2: "Code G: Direct rollover of a distribution to a qualified plan",
    3: "Code H: Direct rollover of a designated Roth account distribution to a Roth IRA",
    4: "Code J: Early distribution from a Roth IRA, no known exception",
    5: "Code K: Distribution of traditional IRA assets not having a readily available FMV",
    6: "Code N: Recharacterized IRA contribution made for 2022 and recharacterized in 2022",
    7: "Code Q: Qualified distribution from a Roth IRA",
    8: "Code R: Recharacterized IRA contribution made for 2021 and recharacterized in 2022",
    9: "Code S: Early distribution from a SIMPLE IRA in first 2 years, no known exception",
    10: "Code T: Roth IRA distribution, exception applies",
  },
  CODE_OPTIONS_CASH: {
    1: "Code 1: Early distribution, no known exception",
    2: "Code 2: Early distribution, exception applies",
    3: "Code 3: Disability",
    4: "Code 4: Death",
    5: "Code 6: Section 1035 exchange",
    6: "Code 7: Normal distribution",
    7: "Code 8: Excess contributions plus earnings taxable in 2022",
    8: "Code 9: Cost of current life insurance protection",
    9: "Code C: Reportable death benefits under section 6050Y",
    10: "Code D: Annuity payments from nonqualified annuities that may be subject to tax under section 1411",
    11: "Code E: Distributions under Employee Plans Compliance Resolution System (EPCRS)",
    12: "Code F: Charitable gift annuity",
    13: "Code L: Loans treated as distributions under section 72(p)",
    14: "Code M: Qualified plan loan offset",
    15: "Code P: Excess contributions plus earnings taxable in 2021",
    16: "Code U: Dividend distribution from ESOP under section 404(k)",
    17: "Code W: Charges or payment for purchasing qualified long-term care insurance contracts under combined arrangements",
    18: "Code A: May be eligible for 10-year tax option",
  },
  CODE_OPTIONS_CASH_ROLLOVER: {
    1: "Code 1: Early distribution, no known exception",
    2: "Code 2: Early distribution, exception applies",
    3: "Code 3: Disability",
    4: "Code 4: Death",
    5: "Code 6: Section 1035 exchange",
    6: "Code 7: Normal distribution",
    7: "Code 8: Excess contributions plus earnings taxable in 2022",
    8: "Code 9: Cost of current life insurance protection",
    9: "Code C: Reportable death benefits under section 6050Y",
    10: "Code D: Annuity payments from nonqualified annuities that may be subject to tax under section 1411",
    11: "Code E: Distributions under Employee Plans Compliance Resolution System (EPCRS)",
    12: "Code F: Charitable gift annuity",
    13: "Code L: Loans treated as distributions under section 72(p)",
    14: "Code M: Qualified plan loan offset",
    15: "Code P: Excess contributions plus earnings taxable in 2021",
    16: "Code U: Dividend distribution from ESOP under section 404(k)",
    17: "Code W: Charges or payment for purchasing qualified long-term care insurance contracts under combined arrangements",
    18: "Code A: May be eligible for 10-year tax option",
    19: "Code B: Designated Roth account distribution",
    20: "Code G: Direct rollover of a distribution to a qualified plan",
    21: "Code H: Direct rollover of a designated Roth account distribution to a Roth IRA",
    22: "Code J: Early distribution from a Roth IRA, no known exception",
    23: "Code K: Distribution of traditional IRA assets not having a readily available FMV",
    24: "Code N: Recharacterized IRA contribution made for 2022 and recharacterized in 2022",
    25: "Code Q: Qualified distribution from a Roth IRA",
    26: "Code R: Recharacterized IRA contribution made for 2021 and recharacterized in 2022",
    27: "Code S: Early distribution from a SIMPLE IRA in first 2 years, no known exception",
    28: "Code T: Roth IRA distribution, exception applies",
  },

  PAYEE_OPTIONS: {
    1: "Self",
    2: "Beneficiary",
  },
  WAIVEOFF_REASON_OPTIONS: {
    1: "To a beneficiary on or after the death of the participant,",
    2: "Participant is disabled",
    3: "After separation from service if separation occurred during or after the calendar year in which the participant reached age 55",
    4: "To an alternate payee under a qualified domestic relations order (QDRO)",
    5: "To a participant for medical care up to the amount allowable as a medical expense deduction",
    6: "To reduce excess contributions",
    7: "To reduce excess employee or matching employer contributions",
    8: "To reduce excess elective deferrals",
    9: "IRS levy on the plan.",
    10: "On account of disasters for which IRS relief has been granted",
  },
  DISTRIBUTION_MODES: {
    1: "Self",
    2: "Traditional IRA",
    3: "Roth IRA",
    4: "Employer sponsored",
    5: "Beneficiary",
  },
  DISTRIBUTION_MODES_INSERVICE: {
    1: "Cash Distribution",
  },
  PAYMENT_OPTIONS: {
    2: "EFT",
    1: "Mail Check to Address",
  },
  FORFEITURE_EVENTS: {
    0: "Full Distribution",
    1: "5 Years BIS",
  },
  FORFEITURE_STATUS: {
    0: "Active",
    1: "InActive",
    2: "InProgress",
  },
  FEES_TYPE: {
    1: "Balance based",
    2: "Investment based",
  },
  ALLOCATION_TYPE: {
    1: "Fixed amount",
    2: "Percentage/Basis Points",
    3: "Tiered",
  },
};

export const TRANSFER_STATUS = {
  1: "In Progress",
  2: "Awaiting Trade",
};

export const DEFAULT_PROMPT_MESSAGE =
  "Your changes may be lost; Do you want to Continue?";

export const screenContext = {
  plan: "plan",
  company: "company",
};

export const contextIds = {
  planDetails: "planDetails",
  companyDetails: "companyDetails",
};

export const SOURCE_CATEGORY_NAME_MAPPING = {
  Deferral: 2,
  EmployeeOther: 4,
  Discretionary: 5,
  Match: 6,
  MatchRoth: 7,
  NonElectiveRoth: 8,
  EmployerOther: 9,
  PrevailingWages: 10,
};

export const SOURCE_SUB_CATEGORY_NAME_MAPPING = {
  Pre_Tax: 5,
  Catch_Up: 10,
  After_Tax: 4,
  Roth: 6,
  After_Tax_Rollover: 7,
  Pre_Tax_Rollover: 8,
  Roth_Rollover: 9,
  QMAC: 1,
  QNEC: 2,
};

export const ELIGIBILITY_RULE_MAPPING = {
  Plan: 1,
  Source: 2,
};

export const ENTRYDATECLASSIFICATION_RULE_MAPPING = {
  Plan: 1,
  Source: 2,
};
export const DISTRIBUTION_WITHDRAWAL_TYPE = {
  In_Service: 1,
  Hardship: 2,
  Required_Minimum_Distribution: 3,
  Separation_from_Service: 4,
  Permissible_Withdrawal: 5,
  Force_Out: 6,
  QBAD: 7,
};

export const FORM_PLACEHOLDERS = {
  ssn: "XXX-XX-XXXX",
  phone: "___-___-____",
  zip: "_____-____",
};

export const ENROLLMENT_DROPDOWN_OPTIONS = {
  EXCLUDED_EMPLOYEE_CLASSIFICATION: {
    1: "Classification 1",
    2: "Classification 2",
    3: "Classification 3",
    4: "Classification 4",
    5: "Classification 5",
  },
  EXCLUDED_EMPLOYEMENT_STATUS: {
    1: "Employment status 1",
    2: "Employment status 2",
    3: "Employment status 3",
    4: "Employment status 4",
    5: "Employment status 5",
  },
  WINDOW_PERIOD: {
    1: "After eligibility requirement date",
    2: "Before entry date",
    3: "After date of hire",
    4: "After eligibility run date",
  },
  WINDOW_PERIOD_FOR_REENROLLMENT: {
    1: "After optout reset",
  },
  paymentOptions: {
    1: "Cheque",
    2: "EFT",
  },
};

// export const INVESTMENTS_BASED_ON = {
//     Age : 1,
//     Birthdate : 2,
//     RetirementDate : 3,
// };

export const applicablePaymentMethodsLoan = [
  {
    label: "Direct Payments",
    value: 1,
  },
  {
    label: "Payroll Deductions",
    value: 2,
  },
];

export const repaymentMethods = [
  {
    label: "Payroll Deductions",
    value: 2,
  },
  {
    label: "Direct Payments",
    value: 1,
  },
  {
    label: "Both",
    value: 3,
  },
];

export const modifyLoanOptions = [
  { label: "Loan Refinancing", value: 1 },
  { label: "Loan Reamortization", value: 2 },
  { label: "Suspend", value: 3 },
];

export const LTPTVestingComputationPeriod = [
  { label: "Anniversary of hire", value: 1 },
  { label: "Plan year after anniversary of hire", value: 2 },
];

export const LTPTServiceCreditPeriod = [
  { label: "At the end of eligibility calculation period", value: 1 },
  { label: "Immediately after the hours condition is satisfied", value: 2 },
];

export const INVESTMENTS_BASED_ON = [
  {
    label: "Age",
    value: 1,
  },
  {
    label: "BirthDate",
    value: 2,
  },
  {
    label: "RetirementDate",
    value: 3,
  },
];

export const IRSCategory = {
  1: "Limit415",
  2: "Catch Up",
  3: "Compensation Limit",
  4: "HCE Definition",
  5: "Compensation For Key Employee",
  6: "Taxable Wage base",
  7: "Limit 402g",
  8: "Limit 408p",
  9: "Limit 219p",
  10: "Limit 457b2",
  11: "Minimum Compensation Amount 408k2",
  12: "Limit 457e18",
  13: "W2 Limit",
};

export const getUserRole = (x) => {
  let name;
  switch (x) {
    case 1:
      name = "Admin";
      break;
    case 2:
      name = "Sponsor";
      break;
    case 5:
      name = "PRI";
      break;
    case 6:
      name = "PRPR";
      break;
    case 7:
      name = "PRQC";
      break;
    case 8:
      name = "VOU";
      break;
    case 9:
      name = "SPU";
      break;
    case 10:
      name = "PLSH";
      break;
    case 11:
      name = "PLSM";
      break;
    case 12:
      name = "PLSL";
      break;
    case 3:
      name = "Participant";
      break;
  }
  return name;
};

export const LOAN_STATUS = {
  1: "InProgress",
  2: "Deleted",
  3: "AwaitingApproval",
  4: "Rejected",
  5: "Suspended",
  6: "Approved",
  7: "AwaitingTrade",
  8: "Active",
  9: "Delinquent",
  10: "DefaultDeemedDistribution",
  11: "DefaultBenefitOffset",
  12: "Closed",
  13: "RefinancingRequestAwaitingApproval",
  14: "ReAmortizationRequestAwaitingApproval",
  15: "RefinancingRequestAwaitingTrade",
  16: "ReAmortizationRequestAwaitingTrade",
  17: "ClosedByRefinancing",
  18: "ClosedByReAmortization",
  19: "ClosedBySuspension",
  20: "DocusignVerificationInProgress",
  21: "DocusigneSignatureRejected",
  22: "DocusigneSignatureVoided",
};

export const LOAN_STATUS_REPORT = {
  1: "In Progress",
  2: "Deleted",
  3: "Awaiting Approval",
  4: "Rejected",
  5: "Suspended",
  6: "Approved",
  7: "Awaiting Trade",
  8: "Active",
  9: "Delinquent",
  10: "Default Deemed Distribution",
  11: "Default Benefit Offset",
  12: "Closed",
  13: "Refinancing Request Awaiting Approval",
  14: "ReAmortization Request Awaiting Approval",
  15: "Refinancing Request Awaiting Trade",
  16: "ReAmortization Request Awaiting Trade",
  17: "Closed By Refinancing",
  18: "Closed By ReAmortization",
  19: "Closed By Suspension",
  20: "Docusign Verification In Progress",
  21: "Docusign eSignature Rejected",
  22: "Docusign eSignature Voided",
};

export const LOAN_MODIFICATION_TYPE = {
  1: "ReAmortize",
  2: "ReFinance",
};

export const getWithdrawalStatus = (x) => {
  let name;
  switch (x) {
    case 1:
      name = "Request In Progress";
      break;
    case 2:
      name = "Approval In Progress";
      break;
    case 3:
      name = "Approved";
      break;
    case 4:
      name = "Rejected";
      break;
    case 5:
      name = "TradeInitiated";
      break;
    case 6:
      name = "TradeCompleted";
      break;
    case 7:
      name = "TradeRejected";
      break;
    case 8:
      name = "Disbursed";
      break;
    case 9:
      name = "Docu Sign Verification InProgress";
      break;
    case 10:
      name = "Cancelled - e-Sign Rejectedl";
      break;
    case 11:
      name = "Cancelled - e-Sign No Action";
      break;
  }
  return name;
};

export const getWithdrawalName = (x) => {
  let name;
  switch (x) {
    case 1:
      name = "In-Service - ";
      break;
    case 2:
      name = "Hardship - ";
      break;
    case 3:
      name = "Required Minimum Distribution - ";
      break;
    case 4:
      name = "Separation from Service - ";
      break;
    case 5:
      name = "Permissible Withdrawal- ";
      break;
    case 6:
      name = "Force out - ";
      break;
    default:
      name = "";
  }
  return name;
};

export const getHardshipReason = (x) => {
  let name;
  switch (x) {
    case 1:
      name = "Certain medical expenses";
      break;
    case 2:
      name = "Costs related to purchasing a principal residence";
      break;
    case 3:
      name = "College tuition and education fees for the next 12 months";
      break;
    case 4:
      name = "Expenses required to avoid a foreclosure or eviction";
      break;
    case 5:
      name = "Burial or funeral costs";
      break;
    case 6:
      name = "Home repair after a natural disaster";
      break;
    case 7:
      name = "Covid '19";
      break;
    case 8:
      name = "Other";
      break;
    default:
      name = "";
  }
  return name;
};

export const UploadedFileType = {
  IsDemographyOnly: 1,
  IsPayrollOnly: 2,
  IsBothDemographyAndPayrollOnly: 3,
  IsDataInitialization: 4,
  LFGProfile: 5,
};

export const uploadDocumentThrough = [
  "Upload the signed documents",
  "Sign the document through DocuSign",
];
